import { React, useEffect, useState } from 'react';
import axios from 'axios';
import MetaTags from 'react-meta-tags';
import { useNavigate, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import '../styles/userprogresspage.css';
import BottomFooter from '../components/BottomFooter';

const UserProgressPage = () => {
  const [userTestData, setUserTestData] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]); // new
  const [loadingSubs, setLoadingSubs] = useState(false); // new
  const navigate = useNavigate();
  let item = null;

  const itemStr = localStorage.getItem('isLogin');
  try {
    item = itemStr ? JSON.parse(itemStr) : null;
  } catch (_) {
    item = null;
  }
  const now = new Date();


const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {

    const resize = () =>
        setIsMobile(window.innerWidth <= 768);

    window.addEventListener("resize", resize);

    return () =>
        window.removeEventListener("resize", resize);

}, []);


  const getTestData = async () => {
    try {
      const json = JSON.stringify({
        userid: item.userid,
      });

      const headers = {
        'Content-Type': 'application/json',
      };

      const res = await axios.post(
        'https://epolylearning.com/Services/polyquiz.svc/GetTestData',
        json,
        { headers }
      );

      // Defensive parsing
      const testData =
        res?.data?.GetTestDataResult?.UserScoreList ||
        res?.data?.UserScoreList ||
        res?.data ||
        [];
      setUserTestData(Array.isArray(testData) ? testData : []);
    } catch (error) {
      console.error('GetTestData error:', error);
    }
  };

  // New: fetch user's subscribed categories + expiry
  const getUserSubscriptions = async () => {
    setLoadingSubs(true);
    try {
      const json = JSON.stringify({
        userid: item.userid,
      });
      const headers = { 'Content-Type': 'application/json' };

      const res = await axios.post(
        'https://epolylearning.com/Services/polyquiz.svc/GetUserSubscriptions',
        json,
        { headers }
      );

      // Defensive parsing: your API returns an ARRAY directly at GetUserSubscriptionsResult
      const raw =
        res?.data?.GetUserSubscriptionsResult ||
        res?.data ||
        [];

      // Normalize to array of { category, expiry }
      const subsArray = Array.isArray(raw)
        ? raw.map((s) => {
            const category = s?.Category || '';
            const expiryRaw = s?.ExpiresAT || s?.ExpiresAt || s?.Expires || null;

            // Convert /Date(xxx)/ → readable date string (ISO)
            let expiry = null;
            if (expiryRaw && typeof expiryRaw === 'string') {
              const match = expiryRaw.match(/\/Date\((\d+)(?:[+-]\d+)?\)\//);
              if (match && match[1]) {
                expiry = new Date(Number(match[1]));
              }
            } else if (expiryRaw instanceof Date) {
              expiry = expiryRaw;
            } else if (expiryRaw && !isNaN(Date.parse(expiryRaw))) {
              expiry = new Date(expiryRaw);
            }

            return { category, expiry };
          })
        : [];

      setSubscriptions(subsArray);
    } catch (err) {
      console.warn('GetUserSubscriptions failed:', err);
      setSubscriptions([]);
    } finally {
      setLoadingSubs(false);
    }
  };

  useEffect(() => {
    if (!itemStr || (item && item.expiry < now.getTime())) {
      navigate('/login');
      return;
    }

    getTestData();
    getUserSubscriptions(); // fetch subscriptions
    // eslint-disable-next-line
  }, []);

  // small helper to slugify category -> route
  const slugify = (str = '') =>
    str
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');

  const formatExpiry = (expiryRaw) => {
    if (!expiryRaw) return 'No expiry info';
    try {
      if (expiryRaw instanceof Date) return expiryRaw.toLocaleDateString();
      const d = new Date(expiryRaw);
      if (!isNaN(d.getTime())) {
        return d.toLocaleDateString();
      }
      // try numeric
      const n = Number(expiryRaw);
      if (!isNaN(n)) {
        const maybe = new Date(n > 1e12 ? n : n * 1000);
        if (!isNaN(maybe.getTime())) return maybe.toLocaleDateString();
      }
      return String(expiryRaw);
    } catch {
      return String(expiryRaw);
    }
  };

  const userDisplayName =
    (item && (item.firstname || item.username || item.email || item.name)) || 'User';
    

  return (
    <>
      <MetaTags>
        <title>User Progress Summary and Test Data - PolyQuiz</title>
        <meta id="meta-description" name="description" />
      </MetaTags>

      {/* top area and welcome */}
      <div className="up-container">
        <div className="up-header">
          <h2 className="up-title">Your Practice History and Score</h2>
          <div className="up-underline" />
        </div>

        <p className="up-welcome">👋 Welcome back, {userDisplayName} — Here are your latest practice attempts.</p>

        {/* Subscribed categories (prominent block above table) */}
        <section className="user-subscriptions prominent">
          <div className="us-row">
            <h3 className="us-title">Your Subscribed Categories</h3>
            {/* <div className="us-action">
              <Link to="/all-exam-prep-practice-test" className="ghost-btn small">Browse Exams</Link>
            </div> */}
          </div>

          {loadingSubs ? (
            <div className="us-loading">Loading subscriptions…</div>
          ) : subscriptions && subscriptions.length > 0 ? (
            <div className="us-grid">
              {subscriptions.map((s, i) => (
               
                <article key={i} className="sub-card">
                  <div className="sub-card-left">
                    <div className="sub-card-icon" aria-hidden>
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
                        <circle cx="12" cy="12" r="10" stroke="none" fill="rgba(79,70,229,0.12)"/>
                        <path d="M7 12h10" stroke="#4f46e5" strokeWidth="1.6" strokeLinecap="round" />
                      </svg>
                    </div>



                    <div className="sub-card-meta">
                      <div className="sub-card-title">{s.category.toUpperCase() || 'Unnamed Category'}</div>
                      <div className="sub-card-expiry">Expires: {s.expiry ? formatExpiry(s.expiry) : '—'}</div>
                    </div>
                  </div>

                  <div className="sub-card-actions">
                    <button
                      className="primary-btn-sm"
                      onClick={() =>
                        
                        navigate(`/practice-test-exam-prep/${(s.category).toLowerCase().replace(/\s+/g, '-')}`, {
                          state: { type: 'category-test' },
                        
                        },
                      
                      )
                         
                      }
                      title={`Go to ${s.category} practice`}
                    >
                      Go to Practice
                    </button>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="us-empty">
              { <div className="us-empty-text">You have no active subscriptions.</div>
             /* <div>
                <button className="ghost-btn" onClick={() => navigate('/all-exam-prep-practice-test')}>
                  Browse Exams
                </button>
              </div> */}
            </div>
          )}
        </section>

        {/* Quiz history */}
        <div className="user-progress">
          <h4 className="table-head">Latest Attempted Tests</h4>

          {userTestData.length > 0 ? (
            <>
            {!isMobile && (
            <div className="table-wrap">
              <table className="progress-table">
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Test Name</th>
                    <th>Total Questions</th>
                    <th>Attempted Questions</th>
                    <th>Your Score</th>
                    <th>Rank</th>
                    <th>Percentile</th>
                  </tr>
                </thead>

                <tbody>
                
                  {userTestData.map((it, key) => (
                    <tr key={key}>
                      <td>{key + 1 + '.'}</td>                      
                     <td>
                      {(
                          it.CatName && it.TestCat == "subcategory-test" && it.CatName.trim() !== ''? `${it.CatName} - ${it.TestName}`: it.TestName).toUpperCase()}
                      </td>
                      <td data-label="Questions">{it.MaxScore}</td>
                      <td data-label="Attempted">{it.Attempted}</td>
                      
                     
                      { <td data-label="Score" data-score={String(it.Score)} aria-label={`Score ${it.Score}`}>
                        {it.Score}
                      </td> }

                      <td  data-label="Rank" data-rank={String(it.Rank)} aria-label={`Rank ${it.Rank}`}>
                        {it.Rank}
                      </td>

                      <td data-label="Percentile" data-percentile={`${String(it.Percentile)}%`} aria-label={`Percentile ${it.Percentile} percent`}>
                        {String(it.Percentile) + '%'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            )}

             {/* Mobile Cards */}
    {isMobile && (
      <div className="history-cards">

        {userTestData.map((it, index) => (

          <HistoryCard
            key={index}
            index={index}
            item={it}
          />

        ))}

      </div>
    )}
  </>
          ) : 
          
          
          (
            <div className="progress-text">No Test is attempted by you yet.</div>
          )}
        </div>
      </div>

      

      {/* keep Footer / Navbar usage unchanged (you had Navbar imported earlier) */}
    </>
  );
};

const HistoryCard = ({ item, index }) => {

  return (

    <div className="history-card">

      <div className="history-top">

        <span className="history-number">
          Attempt #{index + 1}
        </span>

        {index === 0 && (
    <span className="latest-badge">
        Most recent
    </span>
)}

      </div>

      <h3 className="history-test-name">

        {(
          item.CatName &&
          item.TestCat === "subcategory-test" &&
          item.CatName.trim() !== ""
            ? `${item.CatName} - ${item.TestName}`
            : item.TestName
        ).toUpperCase()}

      </h3>

      <div className="history-grid">

        <HistoryItem
          label="Questions"
          value={item.MaxScore}
        />

        <HistoryItem
          label="Attempted"
          value={item.Attempted}
        />

        <HistoryItem
          label="Score"
          value={item.Score}
          type="score"
        />

        <HistoryItem
          label="Rank"
          value={item.Rank}
          type="rank"
        />

        <HistoryItem
          label="Percentile"
          value={`${item.Percentile}%`}
          type="percentile"
        />

      </div>

    </div>

  );

};

const HistoryItem = ({ label, value, type }) => (

  <div className="history-item">

    <div className="history-label">

      {label}

    </div>

    <div className={`history-value ${type || ""}`}>

      {value}

    </div>

  </div>

);

export default UserProgressPage;
